import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { IdentityProviderRequest } from "./identity-provider-request";

@Injectable()
export class DataService_SSO {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	IdentityProviderSelectList() {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/IdentityProviderSelectList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	IdentityProviderToggle(IdentityProviderID: number, Active: number) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/IdentityProviderToggle?IdentityProviderID=" + IdentityProviderID + "&Active=" + Active;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	IdentityProviderDelete(IdentityProviderID: number) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/IdentityProviderDelete?IdentityProviderID=" + IdentityProviderID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	IdentityProviderModify(parms: IdentityProviderRequest) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/IdentityProviderModify?";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
